import writeUp from '~static/car-writeup.pdf';
import * as React from 'react';
export default {
  writeUp,
  React
};